module.exports = __webpack_public_path__ + "static/media/logo.4513c5e2.svg";